import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Input, Select, DatePicker, Radio, Checkbox, Collapse, notification, Divider } from 'antd';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { Tabs } from 'antd';
import { EnvironmentOutlined, AuditOutlined, HomeOutlined, FileProtectOutlined } from '@ant-design/icons';


import { RecordFormWrapper } from './Style';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { Button } from '../../../components/buttons/buttons';
import { Main, BasicFormWrapper } from '../../styled';
import { sucursalCreateAction, sucursalReadAction, sucursalListAction } from '../../../redux/administracion/sucursales/actionCreator';
import {
  estadosListAction, municipioListAction, sucursalEsquemasContractualesListAction, sucursalEsquemasCostosListAction
} from '../../../redux/catalogos/actionCreator';
import moment from 'moment';


const dateFormat = 'YYYY-MM-DD';

const SucursalFormView = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const catalogoEstados = useSelector(state => state.CatalogosReducer.estados);
  const catalogoMunicipios = useSelector(state => state.CatalogosReducer.municipios);
  const catalogoEsquemasContractuales = useSelector(state => state.CatalogosReducer.sucursalEsquemasContractuales);
  const catalogoEsquemasCostos = useSelector(state => state.CatalogosReducer.sucursalEsquemasCostos);
  const catalogoRegimenFiscal = useSelector(state => state.CatalogosReducer.regimenFiscal);
  
  const registro = useSelector(state => state.SucursalReducer.record);
  const isLoading = useSelector(state => state.responseReducer.loading);
  const { id } = useParams();
  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(estadosListAction());
    dispatch(sucursalListAction());
    dispatch(sucursalEsquemasContractualesListAction());
    dispatch(sucursalEsquemasCostosListAction());
  }, []);

  useEffect(() => {
    if (id)
      dispatch(sucursalReadAction(id));
    else {
      dispatch(sucursalReadAction());
      form.resetFields();
    }
  }, [id]);

  useEffect(() => {
    if (registro.id) {
      loadCatalogoMunicipios(registro.idEstado);      
      form.setFieldsValue(registro);
    } else {
      form.resetFields();
    }
  }, [form, registro]);

  const loadCatalogoMunicipios = (idEstado) => {
    if (municipioListAction) {
      dispatch(municipioListAction(idEstado));
    }
  }

  const handleSubmit = async (values) => {
    let action = 'create';
    if (id) {
      action = 'update';
    }

    const responseApi = await dispatch(sucursalCreateAction({
      ...values,
      action: action
    }));
    if (responseApi) {
      let mensaje = 'Sucursal creada exitosamente';
      if (action === "update") mensaje = 'Sucursal actualizada exitosamente';
      notification.success({
        message: mensaje,
      });
      form.resetFields();
      history.replace('/admin/sucursales/listado');
    } else {
      notification.error({
        message: 'Error al gestionar sucursal',
      });
    }
  };

  return (
    <>
      <PageHeader
        buttons={[
          <Button className="btn-add_new" size="default" key="1" type="primary">
            <Link to="/admin/sucursales/listado">Ver todas</Link>
          </Button>,
        ]}
        ghost        
        title='FICHA DE LA SUCURSAL'
      />
      <Main>
        <Row gutter={15}>
          <Col xs={24}>
            <Form
              className="add-record-form"
              style={{ width: '100%' }}
              layout="horizontal"
              size="small"
              form={form}
              name="addnew"
              onFinish={handleSubmit}
            >
              <RecordFormWrapper>
                <Cards headless>
                  <Divider orientation='right' plain>DATOS GENERALES <AuditOutlined style={{ fontSize: '16px' }} /></Divider>
                  <BasicFormWrapper>
                    <Form.Item name="id" initialValue="0">
                      <Input hidden />
                    </Form.Item>
                    <Form.Item name="nombre" label="Nombre de la Sucursal" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Input placeholder="Ej. Las Palmas" />
                    </Form.Item>
                    <Form.Item name="telefono_principal" label="Teléfono principal" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="telefono_sucursal" label="Teléfono interno">
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="telefono_ventas" label="Teléfono ventas">
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="email" label="E-mail">
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="sitio_web" label="Sitio web">
                      <Input placeholder="Ej. https://cdentalcaregroup.com" />
                    </Form.Item>
                    <Form.Item name="idEstatusSucursal" label="Estatus de la sucursal" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Radio.Group>
                        <Radio value="1">
                          Activo <small>(en operaciones)</small>
                        </Radio>
                        <Radio value="2">
                          Suspendida <small>(en revisión)</small>
                        </Radio>
                        <Radio value="3">
                          Suspendida <small>(por penalización)</small>
                        </Radio>
                      </Radio.Group>
                    </Form.Item>
                  </BasicFormWrapper>
                  <Divider orientation='right' plain>UBICACIÓN <EnvironmentOutlined style={{ fontSize: '16px' }} /></Divider>
                  <BasicFormWrapper>
                    <Form.Item name="idEstado" label="Estado" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Select placeholder="Selecciona..." options={catalogoEstados} onSelect={(e) => loadCatalogoMunicipios(e)} notFoundContent={'Sin registros'} />
                    </Form.Item>
                    <Form.Item name="idMunicipio" label="Municipio" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Select placeholder="Selecciona..." options={catalogoMunicipios} notFoundContent={'Selecciona un estado'} />
                    </Form.Item>
                    <Form.Item name="calle" label="Calle" rules={[{ required: false }]}>
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="numero" label="Número" rules={[{ required: false }]}>
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="colonia" label="Colonia" rules={[{ required: false }]}>
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="codigo_postal" label="Código postal" rules={[{ required: false }]}>
                      <Input placeholder="" />
                    </Form.Item>
                  </BasicFormWrapper>
                  <Divider orientation='right' plain>OPERACIÓN <HomeOutlined style={{ fontSize: '16px' }} /></Divider>
                  <BasicFormWrapper>
                    <Form.Item name="idEsquemaCostos" label="Esquema de costos" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Select placeholder="Selecciona..." options={catalogoEsquemasCostos} notFoundContent={'Sin registros'} />
                    </Form.Item>
                    <Form.Item name="idEsquemaContractual" label="Esquema contractual" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Select placeholder="Selecciona..." options={catalogoEsquemasContractuales} notFoundContent={'Sin registros'} />
                    </Form.Item>
                    <Form.Item name="fecha_inicio_operaciones" label="Fecha de inicio de operaciones (yyyy-mm-dd)" rules={[{ required: false }, {
                      pattern: /^\d{4}-\d{2}-\d{2}$/,
                      message: 'Escríbe la fecha en el formato indicado',
                    },]}>
                      <Input placeholder='Ej. 2000-09-30' />
                    </Form.Item>
                  </BasicFormWrapper>
                  <Divider orientation='right' plain>DATOS FISCALES <FileProtectOutlined style={{ fontSize: '16px' }} /></Divider>
                  <BasicFormWrapper>
                    <Form.Item name="regimen_fiscal" label="Régimen fiscal" rules={[{required: false }]}>
                      <Select placeholder="Selecciona..." options={catalogoRegimenFiscal} notFoundContent={'Sin registros'} />
                    </Form.Item>                   
                    <Form.Item name="rfc" label="RFC" rules={[{ required: false }]}>
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="razon_social" label="Razón social" rules={[{ required: false }]}>
                      <Input placeholder="" />
                    </Form.Item>                   
                    <Form.Item name="codigo_postal" label="Código postal" rules={[{ required: false }]}>
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="contrasena_sat" label="Contraseña certificado SAT" rules={[{ required: false }]}>
                      <Input placeholder="" />
                    </Form.Item>
                  </BasicFormWrapper>


                  <br />
                  <div className="record-form-actions text-right">
                    <Button size="default" htmlType="Save" type="primary">
                      {isLoading ? 'Cargando...' : 'Guardar'}
                    </Button>
                  </div>
                </Cards>
              </RecordFormWrapper>
            </Form>
          </Col>
        </Row>
      </Main>
    </>
  );
};

export default SucursalFormView;
